import "core-js/modules/es6.regexp.to-string";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: "SiftSelects",
  components: {},
  props: ["sift", "col", "label-width"],
  data: function data() {
    return {
      value: []
    };
  },
  computed: {},
  created: function created() {
    this.value = this.sift.defaultValue ? this.sift.defaultValue : [];
  },
  mounted: function mounted() {},
  destroyed: function destroyed() {},
  methods: {
    setValue: function setValue(value) {
      this.value = value;
    },
    getValue: function getValue() {
      return this.value.toString(",");
    },
    resetValue: function resetValue() {
      this.value = this.value = this.sift.defaultValue ? this.sift.defaultValue : [];
    }
  },
  watch: {},
  filters: {}
};